export var MessageRole;
(function (MessageRole) {
    MessageRole["Human"] = "human";
    MessageRole["AI"] = "ai";
})(MessageRole || (MessageRole = {}));
